import { render, staticRenderFns } from "./nshop-order-view-baseinfo.vue?vue&type=template&id=09df00bf&"
import script from "./nshop-order-view-baseinfo.vue?vue&type=script&lang=js&"
export * from "./nshop-order-view-baseinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports